module.exports = __webpack_public_path__ + "static/media/CVS-CATCH-MS-SPM-CVS-Logo.d2c6ceee.svg";


//////////////////
// WEBPACK FOOTER
// ../shared/src/assets/images/CVS-CATCH-MS-SPM-CVS-Logo.svg
// module id = 501
// module chunks = 0